export const ANSWERS_DATA = {
  keyword: [
    {
      sl7: {
        answerData: "q1",
        DateVal: "quiz01",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "ㄴ = ㅁ",
      },
      md3: {
        answerData: "q2",
        DateVal: "quiz02",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "3글자",
      },
      wc2: {
        answerData: "q3",
        DateVal: "quiz03",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "2글자",
      },
      wi2: {
        answerData: "q4",
        DateVal: "quiz04",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "프랑스 특산품",
      },
      cl4: {
        answerData: "q5",
        DateVal: "quiz05",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "4123 → 1234",
      },
      sb4: {
        answerData: "q6",
        DateVal: "quiz06",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "수︎■무■",
      },
      mj2: {
        answerData: "q7",
        DateVal: "quiz07",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "머리",
      },
      gb11: {
        answerData: "q8",
        DateVal: "quiz08",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "살 좀 빼자.<br/>영어도 하고.",
      },
      bl3: {
        answerData: "q9",
        DateVal: "quiz09",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "한글",
      },
      ee5: {
        answerData: "q10",
        DateVal: "quiz10",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "3글자",
      },
      gm5: {
        answerData: "q11",
        DateVal: "quiz11",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "밖에 나가면 보여요.",
      },
      dk3: {
        answerData: "q12",
        DateVal: "quiz12",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "ㅎㅇ",
      },
      bf8: {
        answerData: "q13",
        DateVal: "quiz13",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "8글자",
      },
      yj4: {
        answerData: "q14",
        DateVal: "quiz14",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "핵심단서를 보자.",
      },
      cl3: {
        answerData: "q15",
        DateVal: "quiz15",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "행운이 있기를",
      },
      양서초: {
        answerData: "q16",
        DateVal: "quiz16",
        titImgclassName: "infoTit",
        hintWhetherIs: true,
        hintContent: "한자리 뺄셈이다.",
      },
    },
  ],
};
